import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exito-reestablecer',
  templateUrl: './exito-reestablecer.component.html',
  styleUrls: ['./exito-reestablecer.component.scss']
})
export class ExitoReestablecerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
